<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加币种介绍</el-button
    >
    <el-dialog
      title="添加币种介绍"
      width="1200px"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      :before-close="handleClose"
    >
      <el-form
        label-width="200px"
        :model="introduction"
        :rules="rules"
        ref="currencyIntroductionForm"
      >
        <el-form-item label="币种名称：" prop="coinName">
          <el-input v-model="introduction.coinName"></el-input>
        </el-form-item>
        <el-form-item label="币种：" prop="coin">
          <el-input v-model="introduction.coin"></el-input>
        </el-form-item>
        <!-- <el-form-item label="币种代码：" prop="coinCode">
          <el-input v-model="introduction.coinCode"></el-input>
        </el-form-item> -->
        <el-form-item label="币种类型：" prop="coinType">
          <el-input v-model="introduction.coinType"></el-input>
        </el-form-item>
        <el-form-item label="发行价：" prop="issuePrice">
          <el-input v-model="introduction.issuePrice"></el-input>
        </el-form-item>
        <el-form-item label="总发行量：" prop="totalAmount">
          <el-input v-model="introduction.totalAmount"></el-input>
        </el-form-item>
        <el-form-item label="流通量：" prop="flowAmount">
          <el-input v-model="introduction.flowAmount"></el-input>
        </el-form-item>
        <el-form-item label="发行日期：" prop="issueDate">
          <el-date-picker
            v-model="introduction.issueDate"
            type="date"
            placeholder="选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="共识机制：" prop="mechanism">
          <el-input v-model="introduction.mechanism"></el-input>
        </el-form-item>
        <el-form-item label="区块浏览器：" prop="blockLink">
          <el-input v-model="introduction.blockLink"></el-input>
        </el-form-item>
        <el-form-item label="项目官网：" prop="projectLink">
          <el-input v-model="introduction.projectLink"></el-input>
        </el-form-item>
        <el-form-item label="Github地址：" prop="githubLink">
          <el-input v-model="introduction.githubLink"></el-input>
        </el-form-item>
        <el-form-item label="白皮书：" prop="whitePaperLink">
          <el-input v-model="introduction.whitePaperLink"></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="coinUrl">
          <Upload
            :value="introduction.coinUrl"
            @input="handleChange('introduction', 'coinUrl', $event)"
            :data="{
              isSprite: false,
              category: 'coin',
              tenantId: 1,
            }"
          ></Upload>
        </el-form-item>
        <el-form-item label="简介：" prop="description">
          <div
            v-for="lang in languages"
            :key="lang.value"
            class="introduction-editor"
          >
            <div class="introduction-editor-header">({{ lang.label }}简介)</div>
            <editor v-model="introduction.description[lang.value]"></editor>
          </div>
        </el-form-item>
        <el-form-item label="团队介绍：" prop="teamDescription">
          <div
            v-for="lang in languages"
            :key="lang.value"
            class="introduction-editor"
          >
            <div class="introduction-editor-header">
              ({{ lang.label }}团队介绍)
            </div>
            <editor v-model="introduction.teamDescription[lang.value]"></editor>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleSave('currencyIntroductionForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Editor from "components/editor";
import LANGUAGES from "common/languages";
import Upload from "components/upload";
export default {
  name: "CreateCurrencyIntroduction",
  data() {
    return {
      dialogVisible: false,
      introduction: {
        description: {},
        teamDescription: {},
      },
      languages: Object.keys(LANGUAGES).map((lang) => ({
        label: LANGUAGES[lang],
        value: lang,
      })),
      rules: {
        coinName: [
          { required: true, message: "请输入币种名称", trigger: blur },
        ],
        coin: [{ required: true, message: "请输入币种", trigger: blur }],
        issueDate: [
          { required: true, message: "请选择发行日期", trigger: blur },
        ],
      },
    };
  },
  components: {
    Editor,
    Upload,
  },
  methods: {
    ...mapActions("currencyIntroductionSetting", ["create"]),
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.create({
            ...this.introduction,
            description: JSON.stringify(this.introduction.description),
            teamDescription: JSON.stringify(this.introduction.teamDescription),
          }).then(() => {
            this.$message.success("添加成功！");
            this.dialogVisible = false;
            this.$emit("refresh", { page: 1 });
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm("还有信息没保存，确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    closeDialog() {
      this.introduction = {
        description: {},
        teamDescription: {},
      };
      // this.$refs['currencyIntroductionForm'].resetFields();
    },
    handleChange(name, type, val) {
      this[name][type] = val;
    },
  },
};
</script>

<style lang="less" scoped></style>
